module.exports = __webpack_public_path__ + "static/76gde-1f7bf96d8065b4b8fb671d94749a8980.gif";